import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10b7b312"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "button-group"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_field = _resolveComponent("van-field");
  const _component_CommonPickerCpt = _resolveComponent("CommonPickerCpt");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  return _openBlock(), _createBlock(_component_van_form, {
    onSubmit: $options.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      title: "产品信息",
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "产品名称",
        value: $data.productName
      }, null, 8, ["value"]), _createVNode(_component_van_field, {
        modelValue: $data.openDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.openDate = $event),
        readonly: "",
        clickable: !$options.readonly,
        required: "",
        name: "openDate",
        label: "赎回开放日",
        placeholder: "请选择",
        "input-align": "right",
        onClickInput: $options.onOpenDateClick
      }, null, 8, ["modelValue", "clickable", "onClickInput"]), _createVNode(_component_CommonPickerCpt, {
        request: $data.openDateRequest,
        requestParameter: $data.openDateParams,
        columnsFieldNames: $data.openDateFieldNames,
        ref: "commonPickerCpt",
        onOnSelectedChange: $options.onOpenDateChange
      }, null, 8, ["request", "requestParameter", "columnsFieldNames", "onOnSelectedChange"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      title: "申请信息",
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "参考净值",
        value: $data.netValueForm.netValue
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "参考净值公布日",
        value: $data.netValueForm.publicDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "存续份额",
        value: $options.leftShareBeforeOpenDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "可赎回份额",
        value: $options.leftShareCanRedemption
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "预计赎回金额",
        value: $options.applicationRedemptionAmount
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "赎回状态",
        value: _ctx.formatSelectColumn($data.codeResItems, 'redemptionStatus', {
          redemptionStatus: $data.netValueForm.redemptionStatus
        })
      }, null, 8, ["value"]), _createVNode(_component_van_field, {
        modelValue: $data.netValueForm.applicationDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.netValueForm.applicationDate = $event),
        readonly: "",
        clickable: !$options.readonly,
        required: "",
        name: "applicationDate",
        label: "赎回申请时间",
        placeholder: "请选择",
        "input-align": "right",
        "error-message-align": "right",
        rules: [{
          required: true,
          message: '请选择申请时间'
        }],
        onClickInput: _cache[2] || (_cache[2] = $event => $options.onPopupDatePickerSelectClick())
      }, null, 8, ["modelValue", "clickable"]), _createVNode(_component_van_field, {
        modelValue: $data.netValueForm.applicationRedemptionShare,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.netValueForm.applicationRedemptionShare = $event),
        required: "",
        readonly: $options.readonly,
        name: "applicationRedemptionShare",
        label: "申请赎回份额",
        placeholder: "请输入份额",
        "input-align": "right",
        "error-message-align": "right",
        type: "number",
        rules: [{
          required: true,
          message: '请输入份额'
        }, {
          pattern: $data.redemptionSharePattern,
          message: '必须大于0且最多两位小数'
        }, {
          validator: $options.redemptionShareValidator,
          message: '申请份额大于可赎回份额'
        }],
        onBlur: $options.onApplicationShareChange
      }, null, 8, ["modelValue", "readonly", "rules", "onBlur"]), _createVNode(_component_van_cell, {
        title: "附件",
        "arrow-direction": "",
        "is-link": "",
        to: {
          name: 'attachmentDetail',
          params: {
            businessId: $data.redemptionId,
            attachmentType: $data.attachmentType,
            flag: $options.readonly ? 'r' : 'w'
          }
        }
      }, null, 8, ["to"]), $data.redemptionId ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        title: "申请进度",
        "arrow-direction": "",
        "is-link": "",
        to: {
          name: 'workFlowDetail',
          params: {
            businessId: $data.redemptionId,
            workFlowDefinitionId: 1
          }
        }
      }, null, 8, ["to"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_PopupDatePickerCpt, {
      ref: "popupDatePickerCpt",
      onOnSelectedChange: $options.onDatePickerSelectedChange
    }, null, 8, ["onOnSelectedChange"]), $data.netValueForm.redemptionStatus == '04' ? (_openBlock(), _createBlock(_component_van_cell_group, {
      key: 0,
      title: "实际赎回信息",
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "实际净值",
        value: $data.netValueForm.actualNetValue
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "实际份额",
        value: $data.netValueForm.actualRedemptionShare
      }, null, 8, ["value"])]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [$options.showCancel ? (_openBlock(), _createBlock(_component_van_button, {
      key: 0,
      plain: "",
      class: "button-group-item",
      type: "danger",
      "loading-type": "spinner",
      loading: $data.cancelLoading,
      "native-type": "button",
      onClick: $options.cancel
    }, {
      default: _withCtx(() => [_createTextVNode("撤销")]),
      _: 1
    }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), !$options.readonly ? (_openBlock(), _createBlock(_component_van_button, {
      key: 1,
      type: "primary",
      class: "button-group-item",
      "loading-type": "spinner",
      loading: $data.submitLoading,
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_createTextVNode("提交")]),
      _: 1
    }, 8, ["loading"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["onSubmit"]);
}